import { Avatar, Box, Chip, Stack, Typography } from '@mui/material';
import { formatGameActivityLabel, isSteamOnline } from '../lib/friendActivity';

export default function FriendActivitySummary({ friend, avatarSize = 40 }) {
  const { profile, primaryGame } = friend;
  const activityLabel = formatGameActivityLabel(primaryGame);
  const isPlayingNow = friend.isPlayingNow ?? primaryGame?.is_currently_playing;
  const showOnline = isSteamOnline(profile?.steam_persona_state, isPlayingNow);
  const onlineDotSize = Math.max(10, Math.round(avatarSize * 0.3));

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      useFlexGap
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      sx={{ width: '100%', textAlign: 'left' }}
    >
      <Box sx={{ position: 'relative', flexShrink: 0, width: avatarSize, height: avatarSize }}>
        <Avatar
          src={profile?.avatar_url}
          alt={profile?.display_name}
          sx={{ width: avatarSize, height: avatarSize }}
        >
          {(profile?.display_name || '?')[0]}
        </Avatar>
        {showOnline && (
          <Box
            aria-label="Online on Steam"
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: onlineDotSize,
              height: onlineDotSize,
              borderRadius: '50%',
              bgcolor: 'success.main',
              border: '2px solid',
              borderColor: 'background.paper',
            }}
          />
        )}
      </Box>
      <Stack spacing={0.5} sx={{ flex: '1 1 8rem', minWidth: 0 }}>
        <Typography
          className="font-semibold text-slate-100"
          sx={{ wordBreak: 'break-word' }}
        >
          {profile?.display_name ?? 'Friend'}
        </Typography>
        <Typography className="text-slate-300" sx={{ wordBreak: 'break-word' }}>
          {primaryGame?.game_name ?? 'No games in the last 2 weeks'}
        </Typography>
        {!primaryGame && !isPlayingNow && (
          <Typography variant="body2" className="text-slate-400">
            Still on your friends list — Steam has not reported recent activity
          </Typography>
        )}
        {activityLabel && (
          <Typography variant="body2" className="text-slate-400">
            {activityLabel}
          </Typography>
        )}
      </Stack>
      {primaryGame?.is_currently_playing && (
        <Chip
          label="Playing now"
          size="small"
          color="success"
          sx={{ flex: { xs: '1 1 auto', sm: '0 0 auto' } }}
        />
      )}
    </Stack>
  );
}
